<div class="vehicle-container">
    <form [formGroup]="vehicleForm" class="manage-vehicle-form">
        <div class="form-row">
            <div class="form-group">
                <label class="required_field_label" for="name">Name</label>
                <input id="name" formControlName="name" [placeholder]="'Enter Name'"
                    [ngClass]="{form_error : vehicleForm.get('name')?.invalid && vehicleForm.get('name')?.touched}" />
                <div class="form_validation_error"
                    [ngClass]="{'form_error' : vehicleForm.get('name')?.invalid && vehicleForm.get('name')?.touched}">
                    <small *ngIf="vehicleForm.get('name')?.errors?.['required']">Name is required</small>
                </div>
               
            </div>
            <div class="form-group">
            
            
                <app-toggle formControlName="active" [toggleId]="'active'" [label]="'Status'"  [disable]="readOnlyMode"

                    [isActive]="vehicleForm.get('active')?.value "></app-toggle>
            </div>
        </div>
      
        <div class="form-row">
            <div class="form-group" style="grid-column: span 2">
                <label for="description" class="form-label">Description</label>
                <textarea [ngStyle]="" class="form-text-area" id="description" placeholder="Enter description"
                    formControlName="description"></textarea>
            </div>
        </div>
 
        
    </form>

</div>